import { InstantAnswerBuilderFn } from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { getGoToBrandReferralsCTA } from "./shared";

export const BrandReferralCreditDiscrepancyIA: InstantAnswerBuilderFn = (
  strictLocalize
) => {
  return {
    titleBuilder: (_context) => {
      return BRAND_REFERRALS_CREDIT_DISCREPANCY_TITLE(strictLocalize);
    },

    descriptionBuilder(_context) {
      return [BRAND_REFERRALS_CREDIT_DISCREPANCY_DESCRIPTION(strictLocalize)];
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getGoToBrandReferralsCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getGoToBrandReferralsCTA(context, strictLocalize)?.getLink?.();
      },
    },
  };
};

const BRAND_REFERRALS_CREDIT_DISCREPANCY_TITLE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "Why is there a credit discrepancy",
  });

const BRAND_REFERRALS_CREDIT_DISCREPANCY_DESCRIPTION = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage:
      "The credit amount depends on the active promotion when you submit the referral. To qualify for the credit, the brand must either use your referral link or select you as their referrer when they sign up on Faire. Check your “Earned credit” for a specific brand by going to “Refer brands” in Account and selecting the “Joined tab”. If you see the messages “Did not use your link” or “Already active,” you’re not eligible for referral credit.",
  });
